(function () {
  'use strict';

  var spicePending = false;
  var spiceTimer = null;
  var DEBOUNCE_MS = 400;

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = typeof url === 'string' ? url : (url.url || '');
      return path.indexOf('/cart/add') !== -1;
    } catch (e) {
      return false;
    }
  }

  function isSpiceAtcTarget(target) {
    if (!target || !target.closest) return false;
    return Boolean(
      target.closest('#spice-spa-addon-bundle-atc-btn') ||
      target.closest('.spice-spa-addon-layouts .spice-spa-addon-bundle-btn') ||
      target.closest('#spiceaddonsappid .spice-spa-addon-bundle-btn')
    );
  }

  function openThemeCartDrawer() {
    spicePending = false;

    if (!document.querySelector('#sidebar-cart')) return;
    if (!window.theme || !theme.Cart || !theme.Cart.prototype || typeof theme.Cart.prototype._onProductAdded !== 'function') {
      return;
    }

    theme.Cart.prototype._onProductAdded();
  }

  function scheduleOpen() {
    if (!spicePending) return;

    clearTimeout(spiceTimer);
    spiceTimer = setTimeout(openThemeCartDrawer, DEBOUNCE_MS);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (isSpiceAtcTarget(event.target)) {
        spicePending = true;
      }
    },
    true
  );

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var tracked = spicePending && isCartAddUrl(input);

      return originalFetch.apply(this, args).then(function (response) {
        if (tracked && response && response.ok) {
          scheduleOpen();
        }
        return response;
      });
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__spiceCartAdd = spicePending && isCartAddUrl(url);
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__spiceCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          scheduleOpen();
        }
      });
    }
    return originalSend.apply(this, arguments);
  };

  // Spice serves 180x thumbs; desktop FBT images render ~300–320px (blurry).
  var SPICE_IMG_MIN_WIDTH = 720;

  function upgradeSpiceImageUrl(url) {
    if (!url || typeof url !== 'string') return url;

    return url.replace(/_(\d+)x(\d*)(?=\.|$|\?)/, function (match, width) {
      var current = parseInt(width, 10) || 0;
      if (current >= SPICE_IMG_MIN_WIDTH) return match;
      return '_' + SPICE_IMG_MIN_WIDTH + 'x';
    });
  }

  function upgradeSpiceImages(root) {
    var scope = root || document.getElementById('spiceaddonsappid');
    if (!scope) return;

    var images = scope.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var src = img.getAttribute('src');
      var nextSrc = upgradeSpiceImageUrl(src);
      if (nextSrc && nextSrc !== src) {
        img.setAttribute('src', nextSrc);
      }

      var srcset = img.getAttribute('srcset');
      if (srcset) {
        var nextSrcset = srcset
          .split(',')
          .map(function (part) {
            var bits = part.trim().split(/\s+/);
            bits[0] = upgradeSpiceImageUrl(bits[0]);
            return bits.join(' ');
          })
          .join(', ');
        if (nextSrcset !== srcset) {
          img.setAttribute('srcset', nextSrcset);
        }
      }
    }
  }

  function watchSpiceImages() {
    upgradeSpiceImages();

    var host = document.getElementById('spiceaddonsappid');
    if (!host || typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function () {
      upgradeSpiceImages(host);
    });
    observer.observe(host, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSpiceImages);
  } else {
    watchSpiceImages();
  }
})();
